import React from 'react'
import './index.scss'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import MatchDetailsRow from '@Components/MatchComponents/MatchDetailsTable/MatchDetailsRow'
import { Recording } from '@Entities/matching/recording-group-details'

interface MatchDetailsTableProps {
    recordings: Recording[]
}

const MatchDetailsTable = (props: MatchDetailsTableProps) => (
    <table className="result-details-table">
        <tbody>
            <tr>
                {/* Note that the term "Product" is used in the labeling here, however recording is used in the data it references. We have a purposeful
                    mismatch (choice made by MLC). Both productTitle and recordingTitle exist in the API and the database however productTitle in the data is
                    more akin to an album than the title of the dsp recording. For whatever reason it was decided that the term product was a better descriptor
                    in the labeling even though it has a different semantic meaning in the data and API. Welcome to hell future developer and you're welcome!*/}
                <th>DSP</th>
                <th>Product Title</th>
                <th>Product Artist</th>
                <th>Product Label</th>
                <th className="with-tooltip">
                    <p>
                        Audio
                        <CustomToolTip
                            type="?"
                            info={
                                'Not all audio links may be available. Older audio may ' +
                                'have been removed from digital streaming platforms.'
                            }
                        />
                    </p>
                </th>
                <th>Details</th>
            </tr>
            {props.recordings?.map((recording) => (
                <MatchDetailsRow recording={recording} key={`${recording.dspMNumber}-${recording.senderResourceId}`} />
            ))}
        </tbody>
    </table>
)

export default MatchDetailsTable
